module.exports = __webpack_public_path__ + "icon-map.svg?757f6c765dcc8c8628e0d6d565849c0f";